<template>
  <section class="login">
    <header class="header">
      <div class="left">
        <img
          alt="Multivision Connect"
          src="../assets/logo.png"
          class="logotype"
        />
      </div>
    </header>
    <main>
      <div class="login-box">
        <div class="field">
          <div class="control">
            <input
              v-model="email"
              class="input"
              type="email"
              placeholder="email"
            />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input
              v-model="password"
              class="input"
              type="password"
              placeholder="password"
              @keyup.enter="login"
            />
          </div>
        </div>
        <button
          type="submit"
          class="button is-primary button-submit is-large"
          @click="login"
        >
          ENTER
        </button>
        <br />
        <br />
        <div class="has-text-danger">{{ error }}</div>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: ''
    };
  },
  mounted() {
    if (this.isAuth) {
      this.$router.push('/');
    }
  },
  methods: {
    login() {
      this.axiosRequest('post', 'auth', {
        username: this.email,
        password: this.password
      })
        .then(response => {
          console.log('LOGIN:', response.data);

          this.$store.commit('setUser', response.data);
          localStorage.setItem('authToken', response.data.token);
          localStorage.setItem('userID', response.data.username_id);
          localStorage.setItem('username', this.email);
          localStorage.setItem('profile', response.data.profile_name);
          window.location.href = this.$route.query.redirect || '/';
        })
        .catch(error => {
          console.error(error);
          if (error.response.status === 401) {
            this.error = 'Login failed';
          }
        });
    }
  }
};
</script>

<style lang="scss">
.login {
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    height: 74px;
    background-color: #2fb3a5;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;

    .left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 320px;
      background: #000000;
      padding-right: 30px;
    }
  }

  main {
    background-image: url('../assets/trama.png');
    background-size: 117px 98px;
    background-repeat: repeat;
    background-position: center center;
    padding: 107px 0 250px 0;
    flex-grow: 1;

    .login-box {
      width: 240px;
      margin: auto;
    }

    input {
      border: none;
      border-bottom: solid 1px #000000;
      margin-bottom: 20px;
      background: transparent;
      text-align: center;
    }

    .button-submit {
      background: $primary-color;
      border-radius: 0;
      margin-top: 40px;
    }
  }
}
</style>
